import React from 'react';
import { Modal } from 'reactstrap';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SMLUnpublishSheet } from './SMLUnpublishSheet';
import styles from './SMLUnpublishPageModal.module.scss';

export interface SMLUnpublishPageModalProps {
  isOpen: boolean;
  accountId: number;
  smartLink: SerializedSmartLink;
  isUnpublishing: boolean;
  closeModal: () => void;
  onUnpublish: () => void;
}

/**
 * The dialog's shell. The body mounts only while it is open: it counts the
 * page's pre-saves and views, and neither is worth fetching for a dialog
 * nobody opened.
 */
const SMLUnpublishPageModalComponent: React.FC<SMLUnpublishPageModalProps> = ({
  isOpen,
  accountId,
  smartLink,
  isUnpublishing,
  closeModal,
  onUnpublish,
}) => (
  <Modal isOpen={isOpen} toggle={closeModal} centered className={styles.dialog} contentClassName={styles.sheet}>
    {isOpen && (
      <SMLUnpublishSheet
        accountId={accountId}
        smartLink={smartLink}
        isUnpublishing={isUnpublishing}
        closeModal={closeModal}
        onUnpublish={onUnpublish}
      />
    )}
  </Modal>
);

export const SMLUnpublishPageModal = TypedMemo(SMLUnpublishPageModalComponent);
